export enum FilterMode {
  Any = 0,
  All = 1,
}
